/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-08-26 15:19:31
 *
 *******************************************************/
import React, { Component } from 'react';
import { Banner, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { getShop } from 'src/helpers';
import history from 'src/routes/history';

type Props = {
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;

class NotifProductVisibilityCustomRangeSlider extends Component<ComposedProps> {
  state = {
    activeInfoBanner: true
  };

  componentDidMount() {
    this.showInfoBanner();
  }

  render() {
    const { i18n } = this.props;

    return this.state.activeInfoBanner ? (
      <div className="notification">
        <div className="infoBanner">
          <Banner
            title={i18n.translate(
              'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_BannerTitle'
            )}
            onDismiss={this.onDismiss}
            status="info">
            <p>
              {i18n.translate(
                'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_Feature1_Content',
                {
                  t: (
                    <strong>
                      {i18n.translate(
                        'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_Feature1_Content_t'
                      )}
                    </strong>
                  )
                }
              )}{' '}
              <Link
                onClick={() => {
                  history.push(
                    '/product-visibility?utm_source=BoostPFS&utm_medium=in-app%20notification&utm_campaign=New%20Feature%20Release%20Aug%202020'
                  );
                }}>
                {i18n.translate(
                  'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_ButtonChildren'
                )}
              </Link>
              .
            </p>
            <p>
              {i18n.translate(
                'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_Feature2_Content',
                {
                  t: (
                    <strong>
                      {i18n.translate(
                        'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_Feature2_Content_t'
                      )}
                    </strong>
                  )
                }
              )}{' '}
              <Link
                onClick={() => {
                  history.push(
                    '/custom-range-slider?utm_source=BoostPFS&utm_medium=in-app%20notification&utm_campaign=New%20Feature%20Release%20Aug%202020'
                  );
                }}>
                {i18n.translate(
                  'AdminHTML.Dashboard.Notifications.notifProductVisibilityCustomRangeSlider_ButtonChildren'
                )}
              </Link>
              .
            </p>
          </Banner>
        </div>
      </div>
    ) : (
      ''
    );
  }

  // Show info banner
  showInfoBanner = () => {
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismissNewProductVisibilityBanner`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss) {
      this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
    }
  };

  onDismiss = () => {
    try {
      localStorage.setItem(`${getShop()}-dismissNewProductVisibilityBanner`, true);
    } catch (error) {}
    this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
  };
}

export default withI18n()(NotifProductVisibilityCustomRangeSlider);
